import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import WarehouseOut from "../../../containers/modules/warehouse/warehouse-out";

export default function WarehouseOutRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="warehouse-out"
      index
      element={
        <AccessControl
          name={"Warehouse Out List"}
          auth={authUser}
          component={() => <WarehouseOut />}
        />
      }
    />
  );
}
